import React from 'react';
import { Helmet } from 'react-helmet-async';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Page from '../Page';
import { grays } from 'app/constants/colors';
import HeaderV2 from 'app/components/HeaderV2';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      overflow: 'hidden',
      flexDirection: 'column',
      flexGrow: 1,
    },
    title: {
      marginTop: '-8vh',
      fontWeight: 'bold',
      color: grays.mine_shaft,
      fontSize: '3.375rem',
    },
    cryingFace: {
      fontSize: '3.125rem',
    },
    p: {
      fontSize: '1rem',
      lineHeight: '1.5',
      color: grays.mine_shaft,
      margin: '0.625rem 0 1.5rem 0',
    },
  }),
);

export function NotFoundPage() {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>404 Page Not Found</title>
        <meta name="description" content="Page not found" />
      </Helmet>
      <Page>
        <HeaderV2 />
        <div className={classes.root}>
          <div className={classes.title}>
            4
            <span
              className={classes.cryingFace}
              role="img"
              aria-label="Crying Face"
            >
              😢
            </span>
            4
          </div>
          <p className={classes.p}>Page not found.</p>
        </div>
      </Page>
    </>
  );
}
